<!--云看地  -->
<template>
  <div style="width:100%;height:100%;">
    <div style="width:100%;height:calc(100% - 35px);position: relative;">
      <v-basemap ref="mymap"></v-basemap>
      <map-legend></map-legend>
      <map-according-switch></map-according-switch>
      <map-search ref="search"></map-search>
      <map-search-results ref="mapsearchresults" v-show="resultViewShow"></map-search-results>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { Notification } from 'element-ui'
import vBasemap from 'components/main-map/base-map'
import mapLegend from '@/views/map-view/mapLegend'
import mapAccordingSwitch from '@/views/map-view/mapAccordingSwitch'
import mapSearchResults from '@/views/map-view/mapSearchResults'
import mapSearch from '@/views/map-view/mapSearch'
import vFooter from 'components/common/indexfooter'
import {mapmanager} from '@/views/class/mapmanager'
import bus from '@/components/common/bus'

import {mapResourceApi} from '@/api/mapResourceApi'
import {markericon} from '@/views/class/markericon'

export default {
// import引入的组件需要注入到对象中才能使用
  components: {
    vBasemap, mapLegend, mapAccordingSwitch, mapSearch, mapSearchResults, vFooter
  },
  data() {
    // 这里存放数据
    return {
      map: null,
      selectMarker: '', // 当前被选中的marker
      currentIcon: '', // 当前的icon
      resultViewShow: false

    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    queryData() {
      const _this = this
      const status = '2'
      const params = {
        status
      }
      mapResourceApi.getLandInfoList(params).then(response => {
        if (response.code === '200') {
          const featuresObj = JSON.parse(response.data)
          mapmanager.map = _this.map
          mapmanager.intiMapLayer(featuresObj.features)
          bus.$emit('initListData', featuresObj.features)
        } else {
          Notification.warning({
            title: '警告',
            message: '加载图层数据出错!',
            type: 'warning'
          })
        }
      })
    },
    clickMarkerHandler(e) {
      const _this = this
      // 把之前选中的图标设置成原来的大小
      if (_this.selectMarker) {
        if (_this.selectMarker.getTooltip()) {
          _this.selectMarker.closeTooltip()
        }
        _this.selectMarker.setIcon(_this.currentIcon)
        _this.selectMarker.bindTooltip(markericon.getTooltipDiv(_this.selectMarker.feature.properties.dkmc), { direction: 'top', offset: L.point(0, -30) })
      }
      const marker = e.layer
      _this.selectMarker = marker
      _this.currentIcon = marker.getIcon()

      const feature = e.sourceTarget.feature
      const ydxz = feature.properties.ydxz.replace(/^\s+|\s+$/g, '')
      marker.setIcon(markericon.maxLandMarkerIcon(ydxz))
      marker.closeTooltip()
      marker.unbindTooltip()
      L.popup({ closeButton: true })
        .setLatLng(marker.getLatLng())
        .setContent('<div style ="padding: 12px;font-size: 16px;width: 200px; text-align: center;">' + feature.properties.dkmc + '</div>')
        .openOn(_this.map)

      // 显示详细信息
      _this.resultViewShow = true
      _this.$refs.mapsearchresults.resultsDetails(feature, true)
      bus.$emit('mapClick')
    }

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    const _this = this
    // 查询数据，初始化地图数据
    this.$event.$on('ready', map => {
      _this.map = map
      _this.queryData()
      _this.map.landMarkerLayerGroup.on('click', e => {
        const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        if (flag) {
          const feature = e.sourceTarget.feature
          const dkid = feature.properties.id
          this.$router.push(
            {name: 'mobileMoreDetails', params: {id: dkid}}
          )
        } else {
          _this.clickMarkerHandler(e)
        }
      })

      /*  L.circle([27.842398471, 113.154482025], {radius: 2}).addTo(map) */
      /* L.marker([27.842398471, 113.154482025]).addTo(map) */
    })
    bus.$on('mapSelectedQueryValue', msg => {
      mapmanager.switchMapLayer(msg)
    })

    bus.$on('initView', msg => {
      this.$refs.search.searchClear()
    })

    // 清除输入框，触发的事件
    bus.$on('searchClear', msg => {
      if (_this.selectMarker) {
        _this.selectMarker.setIcon(_this.currentIcon)
        _this.selectMarker.bindTooltip(markericon.getTooltipDiv(_this.selectMarker.feature.properties.dkmc), { direction: 'top', offset: L.point(0, -30) })
      }
      if (_this.map) {
        _this.map.closePopup()
        if (!msg) {
          _this.map.resultLayerGroup.clearLayers()
          mapmanager.setlandMarkerTooptip(true)
        }
      }
    })
  },
  beforeCreate() {
    //
  }, // 生命周期 - 创建之前
  beforeMount() {
    //
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
    //
  }, // 生命周期 - 更新之前
  updated() {
    //
  }, // 生命周期 - 更新之后
  beforeDestroy() {
    //
  }, // 生命周期 - 销毁之前
  destroyed() {
    //
  }, // 生命周期 - 销毁完成
  activated() {
    //
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
  //@import url(); 引入公共css类
  .main-map {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    cursor: default;
  }
</style>
